const STATS = [
  {
    label: "MEIs ativos no Brasil",
    value: "+16 milhões",
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-5 w-5"
      >
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
  },
  {
    label: "Limite de faturamento",
    value: "R$ 81.000 / ano",
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-5 w-5"
      >
        <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
        <polyline points="17 6 23 6 23 12" />
      </svg>
    ),
  },
  {
    label: "Vencimento do DAS",
    value: "Todo dia 20",
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-5 w-5"
      >
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
      </svg>
    ),
  },
  {
    label: "Valor do DAS",
    value: "A partir de R$ 76,90",
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-5 w-5"
      >
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
        <path d="M4 10h16" />
        <path d="M8 14h.01" />
        <path d="M12 14h.01" />
        <path d="M16 14h.01" />
        <path d="M8 18h.01" />
        <path d="M12 18h.01" />
      </svg>
    ),
  },
  {
    label: "CNAEs permitidos",
    value: "Mais de 467 atividades",
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-5 w-5"
      >
        <rect x="4" y="2" width="16" height="20" rx="2" ry="2" />
        <path d="M9 22v-4h6v4" />
        <path d="M8 6h.01" />
        <path d="M16 6h.01" />
        <path d="M12 6h.01" />
        <path d="M8 10h.01" />
        <path d="M16 10h.01" />
        <path d="M12 10h.01" />
      </svg>
    ),
  },
  {
    label: "CNAEs por MEI",
    value: "Até 16 CNAEs",
    sub: "1 principal + 15 secundários",
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-5 w-5"
      >
        <polygon points="12 2 2 7 12 12 22 7 12 2" />
        <polyline points="2 17 12 22 22 17" />
        <polyline points="2 12 12 17 22 12" />
      </svg>
    ),
  },
];

export function MeiQuickStats() {
  return (
    <section
      aria-label="Dados rápidos do MEI em 2026"
      className="container mx-auto px-4 max-w-5xl mt-6"
    >
      <h2 className="font-display text-xl md:text-2xl font-bold mb-4">
        📊 Dados Rápidos do MEI em 2026
      </h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
        {STATS.map((stat) => (
          <div
            key={stat.label}
            className="rounded-2xl border border-border bg-card p-4 md:p-5 shadow-soft flex flex-col items-center text-center gap-2"
          >
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10 text-primary">
              {stat.icon}
            </div>
            <div className="text-[11px] uppercase tracking-wide text-muted-foreground font-semibold leading-tight">
              {stat.label}
            </div>
            <div className="font-display text-base md:text-lg font-bold text-foreground leading-tight">
              {stat.value}
            </div>
            {stat.sub && (
              <div className="text-[11px] text-muted-foreground leading-tight">{stat.sub}</div>
            )}
          </div>
        ))}
      </div>
      <p className="mt-3 text-xs text-muted-foreground text-center">
        Os dados podem sofrer alterações conforme atualizações da legislação vigente.
      </p>
    </section>
  );
}
